<template>
  <div class="contents">
    <div class="title">
      <h1 v-html="$t('common.top_title', { nickname: myInfo.user_nickname })"></h1>
      <p>{{ $t('common.top_subtitle') }}</p>
    </div>
    <div class="smenu">
      <div class="mypage_sub_title">
        <a href="javascript:" @click="this.$router.back()">
          <img src="../../../assets/img/btn_back.png">
        </a>{{ $t('charge.title') }}
      </div>
      <div class="mypage_point">
        <b>{{ currency(myInfo.points) }}</b>{{ $t('common.point') }}
      </div>
    </div>

    <div class="warp">
      <h2>{{ $t('charge.guide_title') }}</h2>
      <br />
      <div class="guide_text" v-html="$t('charge.guide_text1')" />
      <div class="guide_text" v-html="$t('charge.guide_text2')" />
      <br />
      <br />
      
      <h2>{{ $t('charge.select_item') }}</h2>
      <br />
      <div class="charge_list">
        <ul>
          <li>
            <img src="../../../assets/img/point_01.png">
            <h2>{{ currency(chargeItem[0].POINT) }} P</h2>
            <p>IDR {{ currency(chargeItem[0].PRICE_IN) }}</p>
            <a href="javascript:" @click="onInPay(0)">
              {{ $t('charge.charge_purchase') }}
            </a>
          </li>
          <li>
            <img src="../../../assets/img/point_02.png">
            <h2>{{ currency(chargeItem[1].POINT) }} P</h2>
            <p>IDR {{ currency(chargeItem[1].PRICE_IN) }}</p>
            <a href="javascript:" @click="onInPay(1)">
              {{ $t('charge.charge_purchase') }}
            </a>
          </li>
          <li>
            <img src="../../../assets/img/point_03.png">
            <h2>{{ currency(chargeItem[2].POINT) }} P</h2>
            <p>IDR {{ currency(chargeItem[2].PRICE_IN) }}</p>
            <a href="javascript:" @click="onInPay(2)">
              {{ $t('charge.charge_purchase') }}
            </a>
          </li>
          <li>
            <img src="../../../assets/img/point_04.png">
            <h2>{{ currency(chargeItem[3].POINT) }} P</h2>
            <p>IDR {{ currency(chargeItem[3].PRICE_IN) }}</p>
            <div class="flag">
              <img src="../../../assets/img/point_flag01.png">
            </div>
            <a href="javascript:" @click="onInPay(3)">
              {{ $t('charge.charge_purchase') }}
            </a>
          </li>
          <li>
            <img src="../../../assets/img/point_05.png">
            <h2>{{ currency(chargeItem[4].POINT) }} P</h2>
            <p>IDR {{ currency(chargeItem[4].PRICE_IN) }}</p>
            <div class="flag">
              <img src="../../../assets/img/point_flag02.png">
            </div>
            <a href="javascript:" @click="onInPay(4)">
              {{ $t('charge.charge_purchase') }}
            </a>
          </li>
        </ul>
      </div>
      <div class="clear">
      </div>
    </div>
  </div>
  <PaymentMethodSelectPopup 
    :show="showPaymentMethodSelectPopup"
    :price="chargeItem[selectedItemIndex].PRICE_IN" 
    :point="chargeItem[selectedItemIndex].POINT" 
    :orderId="getOrderId()"
    @close="showPaymentMethodSelectPopup = false"
    @selected="onPaymentMethodSelected" />
</template>

<style lang="scss" scoped src="./Charge.scss"></style>

<script>
import { showToast, currency, requestPost } from "../../../lib/util";
import { EVENT_NAME, CHARGE_ITEM, VIP_ITEM } from "../../../lib/constant";
import PaymentMethodSelectPopup from "./PaymentMethodSelectPopup.vue";

export default {
  name: 'Charge',
  components: {
    PaymentMethodSelectPopup,
  },
  data() {
    let myInfo = this.$store.getters.me;

    return {
      myInfo: myInfo,
      chargeItem: CHARGE_ITEM,
      showPaymentMethodSelectPopup: false,
      selectedItemIndex: 0,
    }
  },
  mounted() {
    this.emitter.on(EVENT_NAME.CHARGE_PAGE_RESUME, this.onPointUpdate);
  },
  beforeUnmount() {
    this.emitter.off(EVENT_NAME.CHARGE_PAGE_RESUME, this.onPointUpdate);
  },
  methods: {
    getOrderId() {
      return `order-${Math.floor(Date.now() / 1000)}-${this.myInfo.uid}-${this.selectedItemIndex}`;
    },
    onInPay: function(itemId) {
      this.selectedItemIndex = itemId;
      this.showPaymentMethodSelectPopup = true;
    },
    onPaymentMethodSelected: function (paymentMethodItem) {
      this.showPaymentMethodSelectPopup = false;
      requestPost(
        'inEsPay/payment',
        {
          uid: this.myInfo.uid,
          item_id: this.selectedItemIndex,
          order_id: this.getOrderId(),
          bank_code: paymentMethodItem.bankCode,
          product_code: paymentMethodItem.productCode,
        },
        response => {
          window.open(response.webRedirectUrl, '_blank');
        },
        (code, msg) => {
          showToast(msg);
        }
      );
    },
    onPointUpdate: function (data) {
      let _app = this;
      let originalPoint = this.myInfo.points;

      console.log('Charge.vue onPointUpdate()');
      requestPost(
        'user/getUserCash',
        {},
        response => {
          console.log('Charge.vue onPointUpdate() getUserCash:', response.points, originalPoint);
          if (response.points > originalPoint) {
            _app.myInfo.points = response.points;
            _app.$store.dispatch('setMyInfo', _app.myInfo);

            showToast(_app.$t('charge.purchase_success', { nickname: _app.myInfo.user_nickname, point: response.points - originalPoint }))
          }
        },
        (code, msg) => {
          showToast(msg);
        }
      );
    },
  },
}
</script>
